// 引入封装的请求方式和加载动画
import { GET, URLS } from '../../utils'
import { types as LoadingTypes } from './loading'


export const types = {
    /* 
        获得的证书数据
    */
    FETCH_CERTIFICATE_DETAIL: 'CERTIFICATE/FETCH_CERTIFICATE_DETAIL',
}

const state = {
    certificate: {
        data: [],    //证书的全部数据
        load_more: false,
        page: 1,
        page_size: 10,
        total_count: 0
    }
}

const getters = {}

const mutations = {
    set_load_more(state, param) {
        state.certificate.load_more = param.value
    },
    set_pagenum(state, param) {
        state.certificate.page = param.value
    },
    set_list_data(state, param) {
        if (state.certificate.page === 1) {
            state.certificate.data = param.data
        } else {
            state.certificate.data = state.certificate.data.concat(param.data)
        }
        state.total_count = param.count
    }
}
const actions = {
    [types.FETCH_CERTIFICATE_DETAIL]({ commit, state }, param) {
        // 打开等待动画
        commit(LoadingTypes.SHOW)
        commit('set_load_more', { 'value': false })
        commit('set_pagenum', { 'value': param.page })

        GET(URLS.show_my_certificate(param.page, param.certificate_id)).then(response => {
            if (response.next) {
                commit('set_load_more', { 'value': true })
            } else {
                commit('set_load_more', { 'value': false })
            }

            //更新数据
            commit('set_list_data', { 'data': response.results, 'count': response.count })
            // 移除等待动画
            commit(LoadingTypes.HIDE)
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}